import React, { Component } from 'react';
import './Header.css';
import logo from '../images/logo.png'; 

class Header extends Component {
  render() {
    return (
      <header className="header-brand">
        <div>
            <div className="business-logo"><img src={logo} width="250" height="82" alt="Logo" /></div>
        </div>
      </header>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js